// frontend/src/pages/Experiences.tsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Experience {
  id: number;
  title: string;
  challenge: string;
  solution: string | null;
  user_name: string;
  product_type: string;
  status: string;
  created_at: string;
}

const Experiences: React.FC = () => {
  const [experiences, setExperiences] = useState<Experience[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('🔄 در حال بارگذاری تجارب...');
    
    fetch('https://fellfell.ir/api/experiences.php', {
      credentials: 'include'
    })
      .then(response => {
        console.log('📦 پاسخ HTTP:', response.status);
        return response.json();
      })
      .then(data => {
        console.log('📦 داده‌های دریافت شده:', data);
        
        if (data.success && Array.isArray(data.data)) {
          console.log('✅ تعداد تجارب:', data.data.length);
          setExperiences(data.data);
        } else {
          setError('داده‌ها به درستی دریافت نشدند.');
          console.error('❌ ساختار داده‌ها نامعتبر است:', data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('❌ خطا در بارگذاری تجارب:', err);
        setError('خطا در بارگذاری تجارب: ' + err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="loading" style={{ textAlign: 'center', padding: '50px' }}>
        ⏳ در حال بارگذاری تجارب...
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error" style={{ padding: '20px', color: '#c62828', background: '#ffebee', borderRadius: '10px' }}>
        ❌ {error}
      </div>
    );
  }

  return (
    <>
      <div className="page-header" style={{ background: '#1e3a1e', color: '#fff', padding: '40px 0' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <h1 style={{ fontSize: '28px' }}>🌾 تجارب کشاورزان</h1>
          <p style={{ color: '#a5d6a7', marginTop: '5px' }}>تجربه‌های موفق کشاورزان ایران</p>
        </div>
      </div>
      
      <section style={{ padding: '30px 0' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          {experiences.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', background: '#fff', borderRadius: '16px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>🌱</div>
              <p style={{ fontSize: '18px', color: '#888' }}>هیچ تجربه‌ای ثبت نشده است</p>
              <p style={{ color: '#aaa', marginTop: '5px' }}>اولین تجربه کشاورزی را شما ثبت کنید!</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '25px' }}>
              {experiences.map(exp => (
                <div 
                  key={exp.id} 
                  style={{ 
                    background: '#fff', 
                    borderRadius: '16px', 
                    padding: '20px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)';
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <span style={{ padding: '3px 12px', borderRadius: '20px', fontSize: '12px', background: '#e8f5e9', color: '#2e7d32' }}>
                      {exp.product_type || 'متفرقه'}
                    </span>
                    <span style={{ fontSize: '12px', color: '#888' }}>
                      {new Date(exp.created_at).toLocaleDateString('fa-IR')}
                    </span>
                  </div>
                  
                  <h3 style={{ margin: '8px 0' }}>
                    <Link to={`/experience/${exp.id}`} style={{ color: '#1e3a1e', textDecoration: 'none' }}>
                      {exp.title}
                    </Link>
                  </h3>
                  
                  <p style={{ color: '#555', fontSize: '14px', lineHeight: '1.6', margin: '8px 0' }}>
                    {exp.challenge?.substring(0, 120) || ''}...
                  </p>
                  
                  {exp.solution && (
                    <div style={{ 
                      background: '#f5faf5', 
                      padding: '10px', 
                      borderRadius: '8px', 
                      margin: '10px 0',
                      fontSize: '13px',
                      color: '#2e7d32'
                    }}>
                      💡 {exp.solution.substring(0, 80)}...
                    </div>
                  )}
                  
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', borderTop: '1px solid #f0f0f0', paddingTop: '12px' }}>
                    <span style={{ fontSize: '13px', color: '#555' }}>👤 {exp.user_name || 'کشاورز'}</span>
                    <Link 
                      to={`/experience/${exp.id}`} 
                      style={{ 
                        padding: '6px 16px', 
                        background: '#2e7d32', 
                        color: '#fff', 
                        borderRadius: '8px', 
                        textDecoration: 'none',
                        fontSize: '13px',
                        fontWeight: '600'
                      }}
                    >
                      مشاهده کامل
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Experiences;